module.exports = __webpack_public_path__ + "static/media/arrorLinkBlack2.d53c40fe.svg";